import React from 'react';
import {Navigate, NavLink, Route, Routes} from "react-router-dom";
import {RouteInfo} from "../../route/RouteHelper";
import "./ContainerStyleSheet.css"
import Dashboard from "../../pages/Dashboard/Dashboard";
import Profile from "../../pages/Profile/Profile";
import CashInfo from "../../pages/CashInfo/CashInfo";
import CashGroups from "../../pages/CashGroups/CashGroups";
import CashUsers from "../../pages/CashUsers/CashUsers";
import ListOfAccounts from "../ListOfAccounts/ListOfAccounts";
import TransactionsList from "../TransactionsList/TransactionsList";
import SavingsDepositTransactions from "../SavingsDepositTransactions/SavingsDepositTransactions";
import Checkout from "../Checkout/Checkout";
import LoinsList from "../../pages/LoinsList/LoinsList";
import Feedbacks from "../../pages/feedbacks/Feedbacks";
import ErrorPage from "../../pages/ErrorPage/ErrorPage";
import CashTransactions from "../../pages/Transactions/Transactions";
import Installments from "../Installments/Installments";
import Election from "../Election/Election";
import OtherPayments from "../OtherPayments/OtherPayments";
import Exit from "../Sidebar/Exit";
import {useState} from "react";
import PaymentTransaction from "../PaymentTransaction/PaymentTransaction";
import TagManagerList from "../../pages/tagManager/TagManagerList";
import {css} from "@emotion/css";
import LoanRequestsList from "../../pages/loanRequestsList/loanRequestsList";
import CashGroupReport from "../../pages/CashGroups/CashGroupReport";
import Avatar from '@mui/material/Avatar';
import avatar from "../../assets/images/avatar/user-5.jpg"
import {styled, alpha} from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import UnionDetailPage from "../../pages/union/UnionDetailPage";
import GeneralAdmin from "../../pages/generalAdmin/GeneralAdmin";
import CostsAndRevenuesCategory from "../../pages/costsAndRevenuesCategory/CostsAndRevenuesCategory";
import {RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";

const Container = () => {
    const StyledMenu = styled((props) => (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            {...props}
        />
    ))(({theme}) => ({
        '& .MuiPaper-root': {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 180,
            color:
                theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
            boxShadow:
                'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': {
                padding: '4px 0',
            },
            '& .MuiMenuItem-root': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                '&:active': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    }));
    const handleCloseDropDown = () => {
        setAnchorEl(null);
    };

    const [openDialog, setOpenDialog] = useState(false)

    const handleClickOpen = () => {
        setOpenDialog(true)
    }
    const handleClose = () => {
        setOpenDialog(false)
    }
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClickOpenDropdown = (event) => {
        setAnchorEl(event.currentTarget);
    };


    return (
        <section className={css`width: 100%;
          overflow-x: hidden;
          height: 100vh;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;`}>
            <section className="topToolbarContainer">
                <section className="flex-grow-1">

                </section>
                <div id="dropdown-menu">
                    <button
                        id="btn-dropdown"
                        aria-controls={open ? 'demo-customized-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClickOpenDropdown}
                    >
                        <Avatar
                            id="avatar"
                            alt="avatar"
                            src={avatar}
                        />
                        <span id="hello" style={{margin: "0 5px"}}>سلام،</span>
                        <span id="welcome">وقت بخیر</span>
                        <div id="btn-dropdown-chevron" className="dropdown-item-icon chevronDown-icon"/>
                    </button>
                    <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                            'aria-labelledby': 'demo-customized-button',
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleCloseDropDown}
                    >
                        <RaikoGridOneColumn
                            className={css`
                              padding: .5rem;
                              gap: .25rem;
                              justify-items: start;
                            `}
                        >
                            <NavLink to={RouteInfo.Profile.url} className={css`width: 100%`}>
                                <MenuItem>
                                    <section className={RouteInfo.Profile.icon}/>
                                    <span className="sidebar-title">{RouteInfo.Profile.name}</span>
                                </MenuItem>

                            </NavLink>

                            <Divider sx={{my: 0.5}} className={css`width: 100%`}/>
                            <MenuItem onClick={handleClickOpen}>
                                <section className="logout-logo"/>
                                <span className="sidebar-title">خروج</span>
                            </MenuItem>
                            {
                                <Exit
                                    openDialog={openDialog}
                                    setOpenDialog={setOpenDialog}
                                    handleClickOpen={handleClickOpen}
                                    handleClose={handleClose}
                                />
                            }
                        </RaikoGridOneColumn>


                    </StyledMenu>

                </div>

                {/*<section className="profileContainer">*/}
                {/*    <section className="d-flex alignItemsCenter">*/}
                {/*        <img className="profileImage" width="32" height="32" src={raiko} alt=""/>*/}
                {/*    </section>*/}
                {/*    <section className="profileToolbarContainer">*/}
                {/*        <ul>*/}
                {/*            <li*/}
                {/*                className={"profile_toolbar_item"}>*/}
                {/*                <NavLink to={RouteInfo.Profile.url}>*/}
                {/*                    <section className={RouteInfo.Profile.icon}/>*/}
                {/*                    <span className="sidebar-title">{RouteInfo.Profile.name}</span>*/}
                {/*                </NavLink>*/}
                {/*            </li>*/}
                {/*            <li*/}
                {/*                className={"profile_toolbar_item alignItemsCenter"}>*/}
                {/*                <section onClick={handleClickOpen}>*/}
                {/*                    <section className="logout-logo"/>*/}
                {/*                    <span className="sidebar-title">خروج</span>*/}
                {/*                </section>*/}
                {/*            </li>*/}
                {/*        </ul>*/}
                {/*      */}
                {/*    </section>*/}
                {/*</section>*/}
            </section>
            <section className="container">
                <Routes>
                    <Route path={RouteInfo.Profile.url} element={<Profile/>}/>
                    <Route path={RouteInfo.union.url} element={<UnionDetailPage/>}/>
                    <Route path={RouteInfo.generalAdmin.url} element={<GeneralAdmin/>}/>
                    <Route path={RouteInfo.ListOfAccounts.url} element={<ListOfAccounts/>}/>

                    <Route path={RouteInfo.CashTransactionsList.url} element={<CashTransactions/>}/>
                    <Route path={RouteInfo.TagsManager.url} element={<TagManagerList/>}/>
                    <Route path={RouteInfo.CostCategoryManager.url} element={<CostsAndRevenuesCategory/>}/>

                    <Route path={RouteInfo.SavingsDepositTransactions.url} element={<SavingsDepositTransactions/>}/>
                    <Route path={RouteInfo.Checkout.url} element={<Checkout/>}/>
                    <Route path={RouteInfo.CashInfo.url} element={<CashInfo/>}/>
                    <Route path={RouteInfo.CashGroups.url} element={<CashGroups/>}/>
                    <Route path={RouteInfo.CashGroupsReport.url} element={<CashGroupReport/>}/>
                    <Route path={RouteInfo.CashUsers.url} element={<CashUsers/>}/>
                    <Route path={RouteInfo.LoinList.url} element={<LoinsList/>}/>
                    <Route path={RouteInfo.LoinRequest.url} element={<LoanRequestsList/>}/>
                    <Route path={RouteInfo.Transactions.url} element={<TransactionsList/>}/>
                    <Route path={RouteInfo.Feedback.url} element={<Feedbacks/>}/>
                    <Route path={RouteInfo.Dashboard.url} element={<Dashboard/>}/>
                    <Route path={RouteInfo.NotFound.url} element={<ErrorPage/>}/>
                    <Route path={RouteInfo.Election.url} element={<Election/>}/>
                    <Route path={RouteInfo.OtherPayments.url} element={<OtherPayments/>}/>
                    <Route path={RouteInfo.Installments.url} element={<Installments/>}/>
                    <Route path={RouteInfo.PaymentTransaction.url} element={<PaymentTransaction/>}/>
                    <Route path="/*" element={<Navigate replace to={RouteInfo.Dashboard.url}/>}/>

                </Routes>
            </section>
        </section>
    )
}
export default Container